import CakeIcon from "@mui/icons-material/Cake";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.swaBlue,
    verticalAlign: "middle",
    fontSize: "30px",
  },
  toolTip: {
    maxWidth: "150px",
    fontSize: "12px",
  },
}));

const StarsBirthdayIcon = (props) => {
  const classes = useStyles();

  return props.toolTipMessage ? (
    <Tooltip title={props.toolTipMessage} arrow placement="right" classes={{ tooltip: classes.toolTip }}>
      <CakeIcon className={classes.icon} />
    </Tooltip>
  ) : (
    <CakeIcon className={classes.icon} />
  );
};

StarsBirthdayIcon.propTypes = {
  toolTipMessage: PropTypes.string,
};

export default StarsBirthdayIcon;
